/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, func } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';

// UI Component
import ZodiacButtonStyles from './ZodiacButtonStyles';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const ZodiacButtons = ({
    title,
    SvgImage,
    setSelectedSign,
    selectedSign,
}) => {
    const styles = ZodiacButtonStyles();
    const dispatch =  useDispatch();
    const handleSelectedSign = () => {
        dispatch(trackEvent({
            eventCategory: 'Zodiac Landing Page',
            eventAction: 'Click',
            eventLabel: title,
            eventName: 'feature_interaction',
        }));
        setSelectedSign(title);
    };
    return (
        <Grid item md={1} className={`${styles.zodiacButton} sign-container`}>
            <button
                type="button"
                onClick={handleSelectedSign}
                onKeyDown={handleSelectedSign}
            >
                <span className={`${styles.zodiacButton} svg-image`}>
                    <img src={SvgImage} alt={title} />
                </span>
                <span
                    className={`my-4 ${styles.zodiacButton} sign-name ${
                        selectedSign.toLowerCase() === title.toLowerCase() ? 'selected' : ''
                        }`}
                    role="region"
                    aria-label={title}
                >
                    {title}{' '}
                </span>
            </button>
        </Grid>
    );
};

ZodiacButtons.propTypes = {
    title: string.isRequired,
    SvgImage: string.isRequired,
    selectedSign: string.isRequired,
    setSelectedSign: func.isRequired,
};

export default ZodiacButtons;
